<template>
<header class="header clear" role="banner">
  <div class="navSecondary">
    <div class="speciesNav">
      <div class="dirNav previous">
        <a :href="getProfileUrl(preNextSpp.previous, state?.groupName)" >
          <svg class="arrowLeft">
            <use xlink:href="@/assets/sprite.svg#icon-chevron"></use>
          </svg>
          <span class="sr-only">{{ $t("profile.topNav.prev") }}</span>
        </a>
        <div class="toolTip left"><span v-html="getSingleDisplaySpeciesName(preNextSpp.previous, state?.groupName)"></span></div>
      </div>
      <div class="dirNav next">
        <a :href="getProfileUrl(preNextSpp.next, state?.groupName)" >
          <svg class="arrowRight">
            <use xlink:href="@/assets/sprite.svg#icon-chevron"></use>
          </svg>
          <span class="sr-only">{{ $t("profile.topNav.next") }}</span>
        </a>
        <div class="toolTip right"><span v-html="getSingleDisplaySpeciesName(preNextSpp.next, state?.groupName)"></span></div>
      </div>
      <div class="breadcrumbWrap">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a :href="browserHomeUrl">Home</a></li>
            <li><a :href="speciesTableUrl + state?.sppGroup?.groupId">{{state?.groupName}}</a></li>
            <li><a v-html="state?.sppName"></a></li>
          </ul>
        </nav>
      </div>
    </div>
    <tab-menu />
  </div>
</header>
</template>
<script>
import { watch, computed, reactive } from 'vue'
import { useApp } from '@/composables/state/profileState';
import { getPreNextRecordInfo } from '@/services/data/biobrowser-data.js';
import MenuPullDown from './MenuPullDown.vue';
import { tabDefinition as intialTabs, getSingleDisplaySpeciesName, getSpeciesNameByGroup, getProfileUrl } from '@/config/profile-config.js';

export default {
  name: 'bread-crumb-navigation',
  components: {
    'tab-menu': MenuPullDown
  },
  props: {
    isHabitat: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  setup (props) {
    const { currentTab, tabs, state, toShowOverviewTab, hasAnyStatusTabSections } = useApp();
    const preNextSpp = reactive({});

    const browserHomeUrl = import.meta.env.VITE_APP_BIOBROWSER_HOME_URL;
    const speciesTableUrl = import.meta.env.VITE_APP_SPP_TABLE_URL;
    watch(() => state.tsn, async (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        const data = await getPreNextRecordInfo(state, props.isHabitat);
        Object.assign(preNextSpp, data);
      }
    });
    const showDropDown = computed(() => {
      return Object.keys(tabs.value).length > 1;
    });
    return {
      browserHomeUrl,
      speciesTableUrl,
      getProfileUrl,
      state,
      tabs,
      currentTab,
      intialTabs,
      toShowOverviewTab,
      hasAnyStatusTabSections,
      preNextSpp,
      getSingleDisplaySpeciesName,
      getSpeciesNameByGroup,
      showDropDown
    };
  }
}
</script>

<style scoped>
.search-bar-container {
    display: flex;
    position: relative;
    width: 100%;
    height: 36px;
    min-height: 36px;
}
</style>
